import React from 'react'
import { OfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import OfferDesktopFlightToggle from '../Filters/FlightToggle/OfferDesktopFlightToggle'
import useFlightPrice from 'hooks/useFlightPrice'
import moment from 'moment'

interface Props {
  offer: App.HotelOffer | App.BundleOffer | App.VillaOffer
  rooms: Array<OfferPageRoom>
  checkInDate?: string
  checkOutDate?: string
  airport?: App.Airport
}

function HotelDesktopFlightToggle({
  offer,
  rooms,
  checkInDate,
  checkOutDate,
  airport,
}: Props) {
  const nights = checkInDate && checkOutDate ? moment(checkOutDate).diff(checkInDate, 'days') : 1

  const [flightPrice] = useFlightPrice(
    offer.offerFlightsEnabled ? offer.flightDestinationPort : undefined,
    rooms,
    checkInDate,
    checkOutDate,
    airport?.code,
    nights,
  )

  return <OfferDesktopFlightToggle totalFlightPrice={flightPrice} bundledWithFlightsOnly={offer.bundledWithFlightsOnly} />
}

type MappedProps = Pick<Props,
  | 'offer'
  | 'rooms'
  | 'checkInDate'
  | 'checkOutDate'
  | 'airport'
>

export default withOfferPageState((offerState): MappedProps => ({
  airport: offerState.airport,
  offer: offerState.offer!,
  rooms: offerState.rooms,
  checkInDate: offerState.checkInDate,
  checkOutDate: offerState.checkOutDate,
}), HotelDesktopFlightToggle)
